export const OPEN_DIRECT_MESSAGE_EVENT = "link:open-direct-message";

export interface OpenDirectMessageDetail {
  accountXid: string;
  draft?: string;
  sendImmediately?: boolean;
}

/**
 * Requests the app shell to create or open a one-to-one DM. Profile and
 * invite surfaces use this so navigation stays centralized in App.
 */
export function requestDirectMessage(
  accountXid: string,
  draft?: string,
  sendImmediately = false,
): void {
  window.dispatchEvent(
    new CustomEvent<OpenDirectMessageDetail>(OPEN_DIRECT_MESSAGE_EVENT, {
      detail:
        draft === undefined
          ? { accountXid }
          : { accountXid, draft, sendImmediately },
    }),
  );
}
